import DatabankHomePage from "./pages/DatabankHomePage";
import AdminDatabankPage from "./pages/AdminDatabankPage";
import DatabankAnalysisPage from "./pages/DatabankAnalysisPage";
import DatasetPage from "./pages/DatasetPage";
import ElementalCostPage from "./pages/ElementalCostPage";

export const databankRoutes = [
  {
    // The way in: every register offered as a page rather than as ten sidebar
    // entries. It also carries the dues gate — a member behind on
    // subscriptions is told so here rather than hidden from the section.
    path: "/databank",
    element: <DatabankHomePage />,
    roles: [
      "admin",
      "member",
      "fellow",
      "executive",
      "chairman",
      "secretary",
      "probationer",
      "student",
      "technician",
      "assessor",
    ],
  },
  {
    // Gated by permission ALONE, deliberately. RequirePermission requires BOTH
    // when roles and perms are given, so listing roles here would lock out the
    // president — who holds the permission but not the admin role.
    path: "/databank/analysis",
    element: <DatabankAnalysisPage />,
    perms: ["databank.analysis.access"],
  },
  {
    path: "/admin/databank",
    element: <AdminDatabankPage />,
    roles: ["admin"],
  },

  // The per-type registers migrated from the old databank. One route for all of
  // them — `:dataset` is the register key, and the page reads what it needs
  // about the register from the API. Deliberately NOT "/databank/:dataset",
  // which would also swallow "/databank/analysis".
  //
  // Open to the same audience as the price list: browsing is what the databank
  // is FOR. The add/import/delete controls inside the page are admin-only, and
  // every write endpoint behind them is gated on admin|super_admin at the API.
  {
    path: "/databank/register/:dataset",
    element: <DatasetPage />,
    roles: [
      "admin",
      "member",
      "fellow",
      "executive",
      "chairman",
      "secretary",
      "probationer",
      "student",
      "technician",
      "assessor",
    ],
  },

  // Elemental cost analyses are a DOCUMENT library, not a figure register, so
  // they get their own route and screen rather than a `:dataset` key.
  //
  // NO role list, deliberately: this is open to ANY signed-in user, which a
  // role list is not — it would silently shut out firms, graduates and past
  // presidents. RequirePermission with neither roles nor perms means "have a
  // session", which is exactly the rule. Uploading, editing and deleting are
  // still admin-only, gated at the API, and the documents themselves are on the
  // private disk behind an authenticated download.
  {
    path: "/databank/elemental-costs",
    element: <ElementalCostPage />,
  },
];
